import { useRouter } from "next/router";
import { useMemo } from "react";

export const useCallbackUrl = () => {
  const { query } = useRouter();

  const callbackUrl = useMemo(() => {
    const rawCallbackUrl = query?.callbackUrl as string | undefined;

    if (!rawCallbackUrl) {
      return undefined;
    }

    try {
      const url = new URL(rawCallbackUrl, window.location.origin);

      if (url.origin !== window.location.origin) {
        return undefined;
      }

      return rawCallbackUrl;
    } catch {
      return undefined;
    }
  }, [query?.callbackUrl]);

  return callbackUrl;
};
